<template>
  <el-select
    style="width: 100%"
    filterable
    :value="value"
    :placeholder="placeholder"
    :clearable="true"
    :disabled="disabled"
    @input="change($event)"
  >
    <el-option
      v-for="item in list"
      :key="item.id"
      :label="item.productName"
      :value="item.id"
    >
    </el-option>
  </el-select>
</template>

<script>
export default {
  name: 'ProductSelect',
  props: {
    value: {
      required: true,
    },
    placeholder: {
      type: String,
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isOnlyName: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      list: [],
    };
  },
  mounted() {
    this.getProductList();
  },
  methods: {
    async getProductList(keywords = '') {
      const res = await this.$http.post(this.$API.product_list_post, {
        productName: keywords,
        requestSource: 'BACKGROUND_MANAGEMENT',
      });
      if (res?.data) {
        this.list = res.data;
      }
    },
    change(val) {
      const item = this.list.find((v) => v.id === val);
      if (this.isOnlyName) {
        this.$emit('input', item?.productName || '');
      } else {
        this.$emit('input', val);
      }
      this.$emit('update:info', item);
      this.$emit('change', item);
    },
  },
};
</script>
<style lang="scss" scoped>
.isCricle {
  ::v-deep .el-input__inner {
    border-radius: 16px;
  }
}
</style>
